import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useRole } from '@/hooks/useRole';

/**
 * Route guard for the Account Manager dashboard.
 * Admins can also view it for support purposes.
 */
const AmRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const { isAccountManager, isAdmin, isLoading } = useRole();

  if (loading || isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (!isAccountManager && !isAdmin) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
};

export default AmRoute;
